<template>
  <div class="timeOutEmail" :class="{ 'ac-bg-black': ac }">
    <header-component
      :is-soon="false"
      img-left=""
      img-right="/trocachip/img/access.png"
      class="header-component"
      :backRoute="false"
    />
    <div class="change_chip_container">
      <img
        src="img/icons/notifications-alert-triangle.svg"
        id="icon_exclamation"
      />
      <span
        class="timeOutEmail_title"
        id="timeOutEmail_title"
        :class="{ 'ac-color-white': ac }"
        v-html="timeOutEmailPage.title"
      ></span>
      <div class="timeOutEmail_subtitle" id="timeOutEmail_subtitle">
        <span v-html="timeOutEmailPage.subtitle"></span>
      </div>
      <div class="registered_email">
        <span
          class="email_title"
          :class="{ 'ac-color-white': ac }"
          v-html="timeOutEmailPage.emailTitle"
        ></span>
        <span class="subtitle_email" v-html="customer.email"></span>
      </div>
    </div>

    <footer class="timeOutEmail_container-button">
      <button
        class="timeOutEmail_button"
        id="nextFlow"
        @click="nextFlow(timeOutEmailPage.firstButton.flow)"
        :class="{ 'ac-border-yellow': ac, 'ac-color-yellow': ac }"
      >
        {{ timeOutEmailPage.firstButton.text }}
      </button>
      <button
        class="timeOutEmail_button"
        id="nextFlowFinish"
        @click="nextFlowFinish(timeOutEmailPage.secondButton.flow)"
        :class="{ 'ac-border-yellow': ac, 'ac-color-yellow': ac }"
      >
        {{ timeOutEmailPage.secondButton.text }}
      </button>
    </footer>
  </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent";
import { mapState } from "vuex";
import trackEvent from "@/services/trackEvent";

export default {
  name: "timeOutEmail",
  components: {
    HeaderComponent,
  },
  data() {
    return {
      description: "",
      // goToLastRoute: goToLastRoute
    };
  },
  computed: mapState({
    ac: (state) => state.ac,
    document: (state) => state.document,
    config: (state) => state.config,
    customer: (state) => state.customer,
    initFlow: (state) => state.config["init_flow"],
    timeOutEmailPage: (state) => state.config.timeOutEmailPage || {},
    finishingTitles: (state) => state.config.finishingTitles,
  }),
  created() {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.go(1);
    };
    this.sendTracker("screen_etapa_processamento_erro_email", 3);
  },
  methods: {
    nextFlowFinish(flowSelected) {
      this.sendTracker("etapa_processamento_encerrar_troca_chip");
      this.$store.commit("flowSelected", flowSelected);
      this.$router.push({ name: "chipExchangeClosed" });
    },
    nextFlow(flowSelected) {
      this.sendTracker("etapa_processamento_usar_email");
      this.$store.commit("flowSelected", flowSelected);
      this.$router.push({
        name: "finishingScreen",
        params: {
          title: this.finishingTitles.bookingEsinTitle,
          changeEmail: false,
          countTime: this.$route.params.counter,
        },
      });
    },
    sendTracker(eventLabel, eventAction = 2) {
      trackEvent.track({
        user: {
          login: this.customer.login,
          loginType: this.customer.loginType,
          lineType: this.customer.lineType,
          segment: this.customer.segment,
          subSegment: this.customer.subSegment,
          planCode: this.customer.planCode,
          planName: this.customer.planName,
        },
        channel: trackEvent.getChannel(),
        "event-category": 6,
        "event-label": eventLabel,
        "event-location": "mvp esim",
        "event-value": this.customer.isExOiCustomer ? "oi" : "tim",
        "event-status": "Sucesso",
        "event-action": eventAction,
      });
    },
  },
};
</script>

<style lang="scss">
.timeOutEmail {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  .change_chip_container {
    width: 90%;
    height: auto;
    margin: 0 5%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: content-box;
    > img {
      margin-top: 96px;
    }
  }
  .change_chip_email {
    width: 90%;
    height: auto;
    margin: 0 5%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: content-box;
  }
  .timeOutEmail_title {
    width: 309px;
    height: auto;
    font-family: "timsans_bold";
    display: block;
    margin-block-end: 0 !important;
    margin-top: 24px;
    font-size: 18px;
    font-weight: 500;
    line-height: 27px;
    text-align: center;
    color: #000000;
  }
  .registered_email {
    width: 309px;
    height: 48px;
    font-family: "timsans_regular";
    margin: 16px auto 23px auto;
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    > .subtitle_email {
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #696969;
    }
  }
  .email_title {
    width: 309px;
    height: auto;
    font-family: "timsans_bold";
    display: block;
    margin-top: 24px;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    text-align: center;
    color: #000000;
  }
  .timeOutEmail_container-button {
    width: 100%;
    height: auto;
    margin-top: 28px;
    position: fixed;
    bottom: 0;
    justify-content: center;
    display: grid;
    align-items: center;
  }
  .timeOutEmail_button {
    width: 286px;
    height: 52px;
    margin: 0 auto 24px auto;
    border-radius: 26px;
    border: solid 2px #003091;
    background: none;
    outline: none;
    font-size: 1em;
    text-align: center;
    color: #003091;
    &:hover {
      cursor: pointer;
      -webkit-box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
      -moz-box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
      box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
      transition: 1s;
    }
  }
  .timeOutEmail_subtitle {
    width: 309px;
    min-height: 48px;
    margin: 16px auto 23px auto;
    display: block;
    position: relative;
    font-family: "timsans_regular";
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    > span {
      width: 309px;
      height: 48px;
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #696969;
    }
  }
}
</style>
